import React, { Component } from "react";
import _ from "lodash";
import { withRedux } from "../hoc";
import { DetailPageLayout } from "../components";
import { showPromotions } from "../selectors/promotion";

const mapStateToProps = ({ language, t, promotion, promotionPage }) => {
  return {
    language,
    t,
    promotions: _.get(promotion, "data"),
    promotionPage: _.get(promotionPage, "data")
  };
};

@withRedux(mapStateToProps)
export default class PromotionDetail extends Component {
  render() {
    const id = this.props.match.params.id;
    const { promotions, promotionPage } = this.props;
    const video = _.get(promotionPage, "video");
    const imageBanner = _.get(promotionPage, "imageBanner");
    const imageBannerMobile = _.get(promotionPage, "imageBannerMobile");

    const showItems = showPromotions(promotions);

    return (
      <DetailPageLayout
        data={showItems}
        id={_.toInteger(id)}
        path="promotion/detail"
        pageName="PROMOTIONS"
        page="promotions"
        media={video}
        imageBanner={imageBanner}
        imageBannerMobile={imageBannerMobile}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PromotionDetail.js